const drawerObserverTarget = document.querySelector('#bls-header_minicart');

const minicartObserver = new MutationObserver(function(mutations) {
	mutations.forEach(function(mutation) {
		if (mutation.attributeName === 'class') {
			if(drawerObserverTarget.classList.contains('bls__opend-popup-header')){
				if(document?.querySelector('.header_search .predictive-search') && document?.querySelector('.header_search .bls__product-item')){
					document?.querySelector(".bls-minicart-heading")?.click();
				}
			}
		}
	});
});

const drawerObserverConfig = { attributes: true};
if(drawerObserverTarget) {
	minicartObserver?.observe(drawerObserverTarget, drawerObserverConfig);
}
